import type { Feature, FeatureCollection, MultiPolygon, Polygon } from 'geojson';
import type { ApiPrescriptionZone } from 'types/prescription';

import { union } from '@turf/turf';

// Convert a single prescription zone into a GeoJSON Polygon Feature.
// ApiPrescriptionZone.coordinates follows the GeoJSON Polygon shape:
// rings of [longitude, latitude] — outer ring first, then holes.
const zoneToFeature = (zone: ApiPrescriptionZone): Feature<Polygon> => ({
    geometry: {
        coordinates: zone.coordinates,
        type: 'Polygon'
    },
    properties: {},
    type: 'Feature'
});

// Compute a single boundary Feature from the union of all prescription
// zones. Returns null when the zone list is empty or the union fails
// (e.g. all zones are disjoint MultiPolygon — caller decides fallback).
export const computeBoundaryFromZones = (
    zones: ApiPrescriptionZone[]
): Feature<Polygon | MultiPolygon> | null => {
    if (zones.length === 0) {
        return null;
    }

    const features = zones.map(zoneToFeature);

    if (features.length === 1) {
        return features[0];
    }

    try {
        const collection: FeatureCollection<Polygon | MultiPolygon> = {
            features,
            type: 'FeatureCollection'
        };

        return union(collection);
    } catch (error) {
        console.error('computeBoundaryFromZones failed', error);

        return null;
    }
};
